<template lang='pug'>
//- Topbar-Main
div.cancell-topbar(:class='[$style[`cc-topbar`], $style[stateflowBarFixed ? `clear-border` : ``]]')
  div(:class='[$style[`cc-topbar-container`], $style[loginStatus ? `cc-topbar-isLogin` : ``]]')
    //- 得分通知
    ScoreAnimate(:key='`${scoreTicker}-s`' :active='true' :target='scoreStatus.target' :grade='scoreStatus.grade')
    //- Topbar-Logo
    div(:class='$style[`cc-topbar-main`]')
      //- TopBarHamburger(v-if='rwdType === `tablet-m` || rwdType === `mobile`' :title='stateTopBar.isHamburgerFocus ? `關閉選單列` : `展開選單列`')

      div(:class='$style[`cc-topbar-logo`]')
        router-link.img2x(
          role='button'
          tabindex='0'
          aria-label='前往Cancell首頁'
          to='/'
          :class='$style[`cancell-logo`]'
          title='前往Cancell首頁')

      //- Topbar-flowNav
      div(v-if='rwdType === `desktop` || rwdType === `tablet`' :class='$style[`cc-topbar-flow-nav`]')
        router-link(
          tabindex='0'
          aria-label='儀錶板'
          to='/'
          tag='button'
          title='儀錶板'
          :class='$style[`cc-topbar-flow-nav-btn`]')
          span.font-medium 儀錶板
          i(:class='$style[`cc-topbar-flow-nav-wrap-li-new`]') 新

        nav.font-medium(
          :class='$style[`cc-topbar-flow-nav-wrap`]'
          @mouseover='groupNav1 = true'
          @mouseleave="groupNav1 = false")
          span 智慧照護
          IconOpenArrow(:size='14' :color='`#666`')

          div(v-show='groupNav1' :class='$style[`cc-topbar-flow-nav-wrap-ul`]')
            router-link(
              tabindex='0'
              aria-label='前往建立新記錄'
              to='/sideeffect/post'
              tag='button'
              title='建立記錄'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium + 建立記錄

            router-link(
              tabindex='0'
              aria-label='前往求助 Dr.Cell AI'
              to='/?v=0'
              tag='button'
              title='求助 Dr.Cell AI'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 求助 Dr.Cell

            router-link(
              tabindex='0'
              aria-label='前往線上諮詢醫生'
              to='/sideeffect/consult'
              tag='button'
              title='線上問醫生'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 線上問醫生

            router-link(
              tabindex='0'
              aria-label='前往我的ePRO'
              to='/sideeffect/record'
              tag='button'
              title='我的ePRO'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 我的ePRO

            router-link(
              tabindex='0'
              aria-label='前往血糖血壓'
              to='/sideeffect/blood'
              tag='button'
              title='血糖血壓'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 血糖血壓
              //- i(:class='$style[`cc-topbar-flow-nav-wrap-li-new`]') 新

            router-link(
              tabindex='0'
              aria-label='前往報告解說'
              to='/sideeffect/translator'
              tag='button'
              title='報告解說'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 報告解說

            router-link(
              tabindex='0'
              aria-label='前往飲食管家'
              to='/sideeffect/diet'
              tag='button'
              title='飲食管家'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 飲食管家

        nav.font-medium(
          :class='$style[`cc-topbar-flow-nav-wrap`]'
          @mouseover='groupNav2 = true'
          @mouseleave="groupNav2 = false")
          span 衛教與社群
          IconOpenArrow(:size='14' :color='`#666`')

          div(v-show='groupNav2' :class='$style[`cc-topbar-flow-nav-wrap-ul`]')
            router-link(
              tabindex='0'
              aria-label='前往線上課程'
              to='/course'
              tag='button'
              title='有聲課程'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 線上課程
              //- i(:class='$style[`cc-topbar-flow-nav-wrap-li-new`]') 新

            //- router-link(
            //-   tag='button'
            //-   tabindex='0'
            //-   aria-label='使用QA問答庫'
            //-   title='QA問答庫'
            //-   to='/aidoctor'
            //-   :class='$style[`cc-topbar-flow-nav-wrap-li`]')
            //-   span.font-medium QA問答庫

            router-link(
              tabindex='0'
              aria-label='前往講座活動'
              to='/events'
              tag='button'
              title='講座活動'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 講座活動

            a(
              tabindex='0'
              aria-label='前往加入Line社群'
              href='https://line.me/ti/g2/chXi7R_fSWK7XhdmkafV-Qd_rX2mi9clshPpcw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
              title='加入Line社群'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 加入Line社群

        //- nav.font-medium(
        //-   :class='$style[`cc-topbar-flow-nav-wrap`]'
        //-   @mouseover='groupNav3 = true'
        //-   @mouseleave="groupNav3 = false")
        //-   span 社群
        //-   IconOpenArrow(:size='14' :color='`#666`')

        //-   div(v-show='groupNav3' :class='$style[`cc-topbar-flow-nav-wrap-ul`]')
        //-     a(
        //-       tabindex='0'
        //-       aria-label='前往加入Line社群'
        //-       href='https://line.me/ti/g2/chXi7R_fSWK7XhdmkafV-Qd_rX2mi9clshPpcw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
        //-       title='加入Line社群'
        //-       :class='$style[`cc-topbar-flow-nav-wrap-li`]')
        //-       span.font-medium 加入Line社群

            //- router-link(
            //-   tabindex='0'
            //-   aria-label='前往癌友故事卡'
            //-   to='/resume'
            //-   tag='button'
            //-   title='癌友故事卡'
            //-   :class='$style[`cc-topbar-flow-nav-wrap-li`]')
            //-   span.font-medium!= '癌友故事卡'

            //- router-link(
            //-   tabindex='0'
            //-   aria-label='前往癌症討論板'
            //-   to='/qa'
            //-   tag='button'
            //-   title='癌症討論板'
            //-   :class='$style[`cc-topbar-flow-nav-wrap-li`]')
            //-   span.font-medium!= '癌症討論板'

            router-link(
              tabindex='0'
              aria-label='前往公益資源'
              to='/help'
              tag='button'
              title='公益資源'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 公益資源

        nav.font-medium(
          :class='$style[`cc-topbar-flow-nav-wrap`]'
          @mouseover='groupNav4 = true'
          @mouseleave="groupNav4 = false")
          span 價格方案
          IconOpenArrow(:size='14' :color='`#666`')

          div(v-show='groupNav4' :class='$style[`cc-topbar-flow-nav-wrap-ul`]')
            router-link(
              tabindex='0'
              aria-label='一般訂閱方案'
              to='/shop/subscribe'
              tag='button'
              title='一般訂閱方案'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 一般訂閱方案

            router-link(
              tabindex='0'
              aria-label='商務訂閱專案'
              to='/shop/business'
              tag='button'
              title='商務訂閱專案'
              :class='$style[`cc-topbar-flow-nav-wrap-li`]')
              span.font-medium 商務訂閱專案

            //- router-link(
            //-   tabindex='0'
            //-   aria-label='前往保健品商店'
            //-   to='/shop/stuff'
            //-   tag='button'
            //-   title='保健品商店'
            //-   :class='$style[`cc-topbar-flow-nav-wrap-li`]')
            //-   span.font-medium 保健品商店

            //- router-link(
            //-   tabindex='0'
            //-   aria-label='前往訂閱 + 照護組合'
            //-   to='/shop/bundle'
            //-   tag='button'
            //-   title='訂閱 + 照護組合'
            //-   :class='$style[`cc-topbar-flow-nav-wrap-li`]')
            //-   span.font-medium 訂閱 + 照護組合

    //- Topbar-Board UnLogin
    div(v-if='!loginStatus' :class='[$style[`cc-topbar-board`], $style[initLoginSessionDone ? `init-login-done` : ``]]')
      //- router-link(
      //-   tag='button'
      //-   tabindex='0'
      //-   aria-label='使用智能搜尋'
      //-   title='智能搜尋'
      //-   to='/aidoctor'
      //-   :class='$style[`board-sideeffect`]')
      //-   figure(:class='$style[`cc-topbar-sideeffect-avatar-ai`]')
      //-     //- img(:src='`${STATIC_URL}images/vip/p0.webp`' width='100%')
      //-     IconSearch(:size='16' :color='`#333`')
      //-   span 搜尋

      //- router-link(
      //-   role='button'
      //-   tabindex='0'
      //-   aria-label='使用智能搜尋'
      //-   title='智能搜尋'
      //-   to='/aidoctor'
      //-   :class='$style[`board-sideeffect`]')
      //-   figure(:class='$style[`cc-topbar-sideeffect-avatar-ai`]')
      //-     img(:src='`${STATIC_URL}images/vip/p0.webp`' width='100%')
      //-   //- IconSearch(:size='20' :color='stateSearchBarMobileActive ? `#98a1a1` : `#333`')
      //-   span 搜尋

      button(
        title='開始使用'
        tabindex='0'
        aria-label='開始使用'
        :class='$style[`board-setup`]'
        @click='handleClickLogin') 開始使用
        //- figure(:class='$style[`cc-board-avatar-tb`]')
        //-   img(
        //-     :src='`${STATIC_URL}images/common/user/user_default.webp`'
        //-     width='100%'
        //-     height='100%')

      //- transition(name='ani-slide-up-fade')
      //- div(v-if='stateSearchBarMobileActive' :class='$style[`cc-topbar-search-result`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='searchBarClickAwayBlur')
      //-     div(:class='$style[`cc-topbar-searchbar`]' )
      //-       InputSearch(
      //-         v-model='inputSearch.value'
      //-         :defaultValue='inputSearch.value'
      //-         :placeholder='`十大癌症`'
      //-         :class='$style[`cc-searchbar-input`]')
      //-       span(:class='$style[`cc-topbar-searchbar-close`]' @click='searchBarCloseBtn')!= '取消'
      //-     BoardSearch(
      //-       v-show='inputSearch.value'
      //-       :onSearch='searchPreload'
      //-       :passData='dataSearch'
      //-       :passInputValue='inputSearch.value')

      //- div(v-if='stateTopBar.isNotifyFocus' :class='$style[`cc-topbar-notify-board`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='notifyClickAwayBlur')
      //-     BoardNotify(
      //-       :key='`${notifyUpdate}-n`'
      //-       :passData='dataNotify'
      //-       :loadedComplete='notifyLoadComplete'
      //-       @notifyReadUpdate='watchReadNotifyUpdate')

      div(v-if='stateTopBar.isUserPanelFocus' :class='$style[`cc-topbar-userPanel-board`]')
        perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]')
          BoardUserPanel

      div(v-if='stateTopBar.isUserFeatureFocus' :class='$style[`cc-topbar-userFeature-board`]')
        perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]')
          BoardUserFeature

      //- div(v-if='stateTopBar.isHamburgerFocus' :class='$style[`cc-topbar-hamburger-board`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='hamburgerClickAwayBlur')
      //-     BoardHamburger

    //- Topbar-Board Login
    div(v-else :class='[$style[`cc-topbar-board`], $style[`theme-${loginProfile.user_type}`], $style[initLoginSessionDone ? `init-login-done` : ``]]')
      //- div(title='搜尋' :class='$style[`board-icon`]' @click.passive='searchBarClickFocus')
      //-   IconSearch(:size='24' :color='stateSearchBarMobileActive ? `#98a1a1` : `#333`')

      //- button(
      //-   title='查看通知'
      //-   tabindex='0'
      //-   aria-label='查看通知'
      //-   :class='[$style[`board-icon`]]'
      //-   @click.passive='notifyClickFocus')
      //-   IconTips(:size='24' :color='stateTopBar.isNotifyFocus ? `#98a1a1` : `#333`')
      //-   span.font-regular(v-if='dataNotifyCount' :class='[$style[`unread-count`]]') {{ dataNotifyCount > 99 ? '99+' : `${dataNotifyCount}` }}

      button(
        v-if='loginProfile.user_type === `normal` && !loginProfile.vip_trail && loginStatus'
        title='免費14天訂閱'
        tabindex='0'
        aria-label='免費14天訂閱'
        :class='$style[`board-setup`]'
        @click='handleStartFreeTrail') 免費14天訂閱

      router-link(
        v-else
        title='價格方案'
        tabindex='0'
        aria-label='價格方案'
        to='/shop/subscribe'
        :class='$style[`board-setup-shop`]') 價格方案

      //- button(
      //-   title='功能選單'
      //-   tabindex='0'
      //-   aria-label='功能選單'
      //-   v-on-clickaway='userFeatureClickAwayBlur'
      //-   @click.passive='userFeatureClickFocus'
      //-   :class='[$style[`board-icon`], $style[stateTopBar.isUserFeatureFocus ? `cc-selected` : ``]]')
      //-   IconProfile(:size='24' :color='stateTopBar.isUserFeatureFocus ? `#98a1a1` : `#333`')
      //-   span 選單

      button(
        v-if='loginProfile.user_type === `doctor`'
        title='會員功能'
        tabindex='0'
        aria-label='會員功能'
        :title='`${loginProfile.firstName}${loginProfile.lastName} 醫師`'
        :class='[$style[`board-avatar`], $style[`board-login`]]'
        v-on-clickaway='userPanelClickAwayBlur'
        @click.passive='userPanelClickFocus')

        figure(v-if='loginProfile.thumbSrc === ``' :class='$style[`cc-board-avatar-tb`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
            width='100%'
            height='100%')
        figure(v-else :class='$style[`cc-board-avatar-tb`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        span(:class='$style[`cc-board-avatar-tb-text`]') 選單

        div(:class='[$style[`cc-board-avatar-opener`], $style[stateTopBar.isUserPanelFocus ? `cc-isOpened` : ``]]')
          IconOpenArrow(:size='12' :color='`#fff`')

      button(
        v-if='loginProfile.user_type === `normal`'
        tabindex='0'
        aria-label='會員功能'
        :title='`${loginProfile.firstName}${loginProfile.lastName} 會員`'
        :class='[$style[`board-avatar`], $style[`board-login`]]'
        v-on-clickaway='userPanelClickAwayBlur'
        @click.passive='userPanelClickFocus')

        figure(v-if='loginProfile.thumbSrc === `` && !loginProfile.public' :class='$style[`cc-board-avatar-tb`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='loginProfile.thumbSrc !== `` && !loginProfile.public' :class='$style[`cc-board-avatar-tb`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='loginProfile.thumbSrc === `` && loginProfile.public' :class='$style[`cc-board-avatar-tb`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-board-avatar-tb`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        span(:class='$style[`cc-board-avatar-tb-text`]') 選單

        div(:class='[$style[`cc-board-avatar-opener`], $style[stateTopBar.isUserPanelFocus ? `cc-isOpened` : ``]]')
          IconOpenArrow(:size='12' :color='`#fff`')

      //- div(v-if='stateSearchBarMobileActive' :class='$style[`cc-topbar-search-result`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='searchBarClickAwayBlur')
      //-     div(:class='$style[`cc-topbar-searchbar`]' )
      //-       InputSearch(
      //-         v-model='inputSearch.value'
      //-         :defaultValue='inputSearch.value'
      //-         :placeholder='`十大癌症`'
      //-         :class='$style[`cc-searchbar-input`]')
      //-       span(:class='$style[`cc-topbar-searchbar-close`]' @click='searchBarCloseBtn')!= '取消'
      //-     BoardSearch(
      //-       v-show='inputSearch.value'
      //-       :onSearch='searchPreload'
      //-       :passData='dataSearch'
      //-       :passInputValue='inputSearch.value')

      //- transition(name='ani-slide-up-fade')
      //- div(v-if='stateTopBar.isNotifyFocus' :class='$style[`cc-topbar-notify-board`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='notifyClickAwayBlur')
      //-     BoardNotify(
      //-       :key='`${notifyUpdate}-n`'
      //-       :passData='dataNotify'
      //-       :loadedComplete='notifyLoadComplete'
      //-       @notifyReadUpdate='watchReadNotifyUpdate')

      //- transition(name='ani-slide-up-fade')
      div(v-if='stateTopBar.isUserPanelFocus' :class='$style[`cc-topbar-userPanel-board`]')
        perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]')
          BoardUserPanel

      div(v-if='stateTopBar.isUserFeatureFocus' :class='$style[`cc-topbar-userFeature-board`]')
        perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]')
          BoardUserFeature

      //- div(v-if='stateTopBar.isHamburgerFocus' :class='$style[`cc-topbar-hamburger-board`]')
      //-   perfect-scrollbar(:class='$style[`cc-topbar-expand-wrap`]' v-on-clickaway='hamburgerClickAwayBlur')
      //-     BoardHamburger

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import { debounce } from 'debounce';
import axios from 'axios';

import InputSearch from './InputSearch';
import BoardSearch from './BoardSearch';
import BoardNotify from './BoardNotify';
import BoardUserPanel from './BoardUserPanel';
import BoardUserFeature from './BoardUserFeature';
// import BoardHamburger from './BoardHamburger';
import ScoreAnimate from './ScoreAnimate';

import IconSearch from '../../icon/Search';
import IconProfile from '../../icon/Profile';
import IconTips from '../../icon/Tips';
// import IconBookMark from '../../icon/Bookmark';
import IconOpenArrow from '../../icon/OpenArrow';
import IconDonate from '../../icon/Donate';
// import TopBarHamburger from './TopBarHamburger';

import {
  getSearchResults,
  // getUserNotifyList,
} from '../../../js/restapi';

export default {
  components: {
    InputSearch,
    IconSearch,
    IconTips,

    IconOpenArrow,
    IconProfile,
    IconDonate,
    BoardSearch,
    BoardNotify,
    BoardUserPanel,
    BoardUserFeature,
    // BoardHamburger,
    ScoreAnimate,
    // TopBarHamburger,
  },

  mixins: [clickaway],

  props: {
    initLoginSessionDone: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      clientWidth: 0,
      searchPreload: true,
      groupNav1: false,
      groupNav2: false,
      groupNav3: false,
      groupNav4: false,
      inputSearch: {
        value: '',
      },
      dataSearch: {
        doctor: {
          type: 'doctor',
          total: 0,
        },
        article: {
          type: 'article',
          total: 0,
        },
        scoop: {
          type: 'scoop',
          total: 0,
        },
        qa: {
          type: 'qa',
          total: 0,
        },
        resume: {
          type: 'resume',
          total: 0,
        },
        drug: {
          type: 'drug',
          total: 0,
        },
      },
      notifyUpdate: 1,
      dataNotifyCount: 0,
      dataNotify: [],
      notifyLoadComplete: false,
    };
  },

  methods: {
    searchBarClickFocus() {
      this.changeSearchBarMobileActive(true);
      // this.inputSearch.value = '';
      // document.body.classList.add('cc-overflow-hide');
      // if (!this.stateSearchBarMobileActive) {
      //   this.inputSearch.value = '';
      // }
    },

    searchBarCloseBtn() {
      // this.searchMobileToggle = false;
      this.changeSearchBarMobileActive(false);
      this.changeSearchBarFocus(false);
      // document.body.classList.remove('cc-overflow-hide');
      // this.inputSearch.value = '';
    },

    watchReadNotifyUpdate() {
      this.notifyUpdate += 1;
      console.log('watchReadNotifyUpdate', this.notifyUpdate);
    },

    // axiosFirstLoadNotifyEvent() {
    //   getUserNotifyList(`/?pk=${this.loginDjangoId}&size=12&page=1`)
    //     .then((res) => {
    //       this.dataNotify = res.data.results;
    //       this.dataNotifyCount = res.data.count;
    //       this.notifyLoadComplete = true;
    //       // console.log('axiosFirstLoadNotifyEvent', res.data);
    //     })
    //     .catch((err) => {
    //       console.log('err', err);
    //     });
    // },

    searchBarClickAwayBlur() {
      this.changeSearchBarFocus(false);
      this.changeSearchBarMobileActive(false);
      // document.body.classList.remove('cc-overflow-hide');
    },

    // notifyClickFocus() {
    //   this.changeNotify(!this.stateTopBar.isNotifyFocus);
    //   // this.changeSearchBarMobileActive(false);
    //   // this.boardStatus.event.isRead = true;
    //   // if (this.rwdType === 'mobile') {
    //   //   // this.searchMobileToggle = false;
    //   //   // document.body.classList.add('cc-overflow-hide');
    //   //   this.changeSearchBarMobileActive(false);
    //   // }
    // },

    notifyClickAwayBlur() {
      this.changeNotify(false);
      // document.body.classList.remove('cc-overflow-hide');
    },

    userPanelClickFocus() {
      this.changeUserPanel(!this.stateTopBar.isUserPanelFocus);
      this.changeSearchBarMobileActive(false);
      // if (this.rwdType === 'mobile') {
      //   // this.searchMobileToggle = false;
      //   this.changeSearchBarMobileActive(false);
      // }
    },

    userPanelClickAwayBlur() {
      this.changeUserPanel(false);
    },

    userFeatureClickFocus() {
      this.changeUserFeature(!this.stateTopBar.isUserFeatureFocus);
      this.changeSearchBarMobileActive(false);
      // if (this.rwdType === 'mobile') {
      //   // this.searchMobileToggle = false;
      //   this.changeSearchBarMobileActive(false);
      // }
    },

    userFeatureClickAwayBlur() {
      this.changeUserFeature(false);
    },

    // hamburgerClickAwayBlur() {
    //   this.changeHamburgerFocus(false);
    // },

    handleClickLogin() {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    },

    handleStartFreeTrail() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        if (this.loginProfile.user_type === 'doctor') {
          this.changePopBoxStatus({
            active: true,
            include: 'warnNotDoctor',
          });
          return;
        }
        this.changePopFreeTrailStatus({
          active: true,
        });
      }
    },

    // eslint-disable-next-line func-names
    handleSearchBarResultCount: debounce(function () {
      axios.all([
        getSearchResults(`article/?search=${this.inputSearch.value},count`),
        getSearchResults(`scoop/?search=${this.inputSearch.value},count`),
        getSearchResults(`qa/?search=${this.inputSearch.value},count`),
        getSearchResults(`resume/?search=${this.inputSearch.value},count`),
        getSearchResults(`drug/?search=${this.inputSearch.value},count`),
        getSearchResults(`doctor/?search=${this.inputSearch.value},count`),
      ])
        .then(axios.spread((article, scoop, qa, resume, drug, doctor) => {
          // console.log('articlearticle', article.data.count)
          this.dataSearch.article.total = article.data.count;
          this.dataSearch.scoop.total = scoop.data.count;
          this.dataSearch.qa.total = qa.data.count;
          this.dataSearch.resume.total = resume.data.count;
          this.dataSearch.drug.total = drug.data.count;
          this.dataSearch.doctor.total = doctor.data.count;
          this.searchPreload = false;
        }))
        .catch((error) => console.error('SearchBar獲取結果 失敗！'));
    }, 800),

    ...mapActions({
      changeSearchBarMobileActive: 'user/changeTopBarSearchBarMobileActive',
      changeSearchBarFocus: 'user/changeTopBarSearchBarFocus',
      changeNotify: 'user/changeTopBarNotifyFocus',
      changeUserPanel: 'user/changeTopBarUserPanelFocus',
      changeUserFeature: 'user/changeTopBarUserFeatureFocus',
      // changeHamburgerFocus: 'user/changeTopBarHamburgerFocus',
    }),

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopFreeTrailStatus: 'global/POPFREETRAIL_STATUS',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.clientWidthResize);
  // },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      stateflowBarFixed: 'global/exportFlowBarFixed',
      // stateSearchBarMobileActive: 'user/exportTopBarSearchBarMobileActive',
      stateTopBar: 'user/exportTopBarStatus',
      loginStatus: 'user/exportLoginStatus',
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
      scoreStatus: 'user/exportUserScoreStatus',
      scoreTicker: 'user/exportUserScoreTicker',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    // Watch If SearchBar onFocus
    // eslint-disable-next-line func-names
    'inputSearch.value': function () {
      if (!this.stateTopBar.isSearchBarFocus) { return; }
      this.searchPreload = true;
      this.handleSearchBarResultCount();
    },
    // $route(to, from) {
    //   this.inputSearch.value = '';
    //   document.body.classList.remove('cc-overflow-hide');
    //   // this.axiosFirstLoadNotifyEvent();
    // },

    // initLoginSessionDone() {
    //   console.log('initLoginSessionDone Change!!!');
    //   this.axiosFirstLoadNotifyEvent();
    // },

    // notifyUpdate() {
    //   console.log('notifyUpdate');
    //   this.axiosFirstLoadNotifyEvent();
    // },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/topbar/topbar.scss';
</style>
